import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractRentFreeTimeListStatus: 'idle',
    loadContractRentFreeTimeListError: undefined as any,
    loadContractRentFreeTimeListLastArgs: undefined as any,
    loadContractRentFreeTimeStatus: 'idle',
    loadContractRentFreeTimeError: undefined as any,
    saveContractRentFreeTimeStatus: 'idle',
    saveContractRentFreeTimeError: undefined as any,
    deleteContractRentFreeTimeStatus: 'idle',
    deleteContractRentFreeTimeError: undefined as any,

    flsolmfzList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractRentFreeTimeList = createAsyncThunk('flsolmfzSlice/loadContractRentFreeTimeList', async ({ flbel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flsolmfzSlice.loadContractRentFreeTimeListLastArgs
    if (_.isEqual(lastArgs, { flbel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsolmfz/?MIN_FLBELID=${flbel.HDR_ID}&MAX_FLBELID=${flbel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { flbel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRentFreeTimeListStatus } = getState().flsolmfzSlice
        return loadContractRentFreeTimeListStatus !== 'pending'
    }
})

export const loadContractRentFreeTime = createAsyncThunk('flsolmfzSlice/loadContractRentFreeTime', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsolmfz/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRentFreeTimeStatus } = getState().flsolmfzSlice
        return loadContractRentFreeTimeStatus !== 'pending'
    }
})

export const saveContractRentFreeTime = createAsyncThunk('flsolmfzSlice/saveContractRentFreeTime', async ({ flsolmfz }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flsolmfz?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flsolmfz/${ flsolmfz?.HDR_ID }/`,
            prepareData(flsolmfz),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flsolmfz/`,
            prepareData(flsolmfz),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractRentFreeTimeStatus } = getState().flsolmfzSlice
        return saveContractRentFreeTimeStatus !== 'pending'
    }
})

export const deleteContractRentFreeTime = createAsyncThunk('flsolmfzSlice/deleteContractRentFreeTime', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flsolmfz/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractRentFreeTimeStatus } = getState().flsolmfzSlice
        return deleteContractRentFreeTimeStatus !== 'pending'
    }
})

const flsolmfzSlice = createSlice({
    name: 'flsolmfzSlice',
    initialState,
    reducers: {
        resetloadContractRentFreeTimeListError: (state) => {
            state.loadContractRentFreeTimeListError = undefined
        },
        resetloadContractRentFreeTime: (state) => {
            state.formItem = undefined
            state.loadContractRentFreeTimeError = undefined
        },
        resetloadContractRentFreeTimeError: (state) => {
            state.loadContractRentFreeTimeError = undefined
        },
        resetsaveContractRentFreeTime: (state) => {
            state.formItem = undefined
            state.saveContractRentFreeTimeError = undefined
        },
        resetsaveContractRentFreeTimeError: (state) => {
            state.saveContractRentFreeTimeError = undefined
        },
        resetdeleteContractRentFreeTimeError: (state) => {
            state.deleteContractRentFreeTimeError = undefined
        },
        removeFromFlsolmfzListById: (state, action) => {
            state.flsolmfzList = state.flsolmfzList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlsolmfzListByIds: (state, action) => {
            state.flsolmfzList = state.flsolmfzList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flsolmfzList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractRentFreeTimeListStatus = 'preloaded'
            state.loadContractRentFreeTimeListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flsolmfzList = []
            state.loadContractRentFreeTimeListStatus = 'idle'
            state.loadContractRentFreeTimeListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRentFreeTimeList.pending, (state) => {
            state.loadContractRentFreeTimeListStatus = 'pending'
            state.loadContractRentFreeTimeListError = undefined
        })
        builder.addCase(loadContractRentFreeTimeList.fulfilled, (state, action) => {
            state.loadContractRentFreeTimeListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractRentFreeTimeListLastArgs = action.payload.args

            {
                state.flsolmfzList = action.payload.data

            }
        })
        builder.addCase(loadContractRentFreeTimeList.rejected, (state, action) => {
            state.loadContractRentFreeTimeListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRentFreeTimeListError = action.error.message
            } else {
                state.loadContractRentFreeTimeListError = action.payload
            }
        })

        builder.addCase(loadContractRentFreeTime.pending, (state) => {
            state.loadContractRentFreeTimeStatus = 'pending'
            state.loadContractRentFreeTimeError = undefined
        })
        builder.addCase(loadContractRentFreeTime.fulfilled, (state, action) => {
            state.loadContractRentFreeTimeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flsolmfzList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flsolmfzList.push(newItem) }
                else { state.flsolmfzList[i] = { ...state.flsolmfzList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractRentFreeTime.rejected, (state, action) => {
            state.loadContractRentFreeTimeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRentFreeTimeError = action.error.message
            } else {
                state.loadContractRentFreeTimeError = action.payload
            }
        })

        builder.addCase(saveContractRentFreeTime.pending, (state) => {
            state.saveContractRentFreeTimeStatus = 'pending'
            state.saveContractRentFreeTimeError = undefined
        })
        builder.addCase(saveContractRentFreeTime.fulfilled, (state, action) => {
            state.saveContractRentFreeTimeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flsolmfzList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flsolmfzList.push(newItem) }
                else { state.flsolmfzList[i] = { ...state.flsolmfzList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractRentFreeTime.rejected, (state, action) => {
            state.saveContractRentFreeTimeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractRentFreeTimeError = action.error.message
            } else {
                state.saveContractRentFreeTimeError = action.payload
            }
        })

        builder.addCase(deleteContractRentFreeTime.pending, (state) => {
            state.deleteContractRentFreeTimeStatus = 'pending'
            state.deleteContractRentFreeTimeError = undefined
        })
        builder.addCase(deleteContractRentFreeTime.fulfilled, (state, action) => {
            state.deleteContractRentFreeTimeStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flsolmfzList = state.flsolmfzList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flsolmfzList = state.flsolmfzList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractRentFreeTime.rejected, (state, action) => {
            state.deleteContractRentFreeTimeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRentFreeTimeError = action.error.message
            } else {
                state.deleteContractRentFreeTimeError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRentFreeTimeListError,
    resetloadContractRentFreeTime,
    resetloadContractRentFreeTimeError,
    resetsaveContractRentFreeTime,
    resetsaveContractRentFreeTimeError,
    resetdeleteContractRentFreeTimeError,
    removeFromFlsolmfzListById,
    removeFromFlsolmfzListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = flsolmfzSlice.actions
export default flsolmfzSlice.reducer
